"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _featureFlags = require("./featureFlags");
Object.keys(_featureFlags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _featureFlags[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _featureFlags[key];
    }
  });
});
var _initializeLaunchDarkly = require("./initializeLaunchDarkly");
Object.keys(_initializeLaunchDarkly).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _initializeLaunchDarkly[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _initializeLaunchDarkly[key];
    }
  });
});